class CountryModel {
	id = '';

	name = '';

	vat = '';

	constructor({
		id = '',
		name = '',
		vat = '',
	}) {
		this.id = id;
		this.name = name;
		this.vat = vat;
	}
}

class BillingInformationModel {
	id = '';

	name = '';

	address = '';

	postalCode = '';

	city = '';

	country = '';

	fiscalId = '';

	constructor({
		id = '',
		name = '',
		address = '',
		// eslint-disable-next-line camelcase
		postal_code = '',
		city = '',
		countryDto = null,
		// eslint-disable-next-line camelcase
		fiscal_id = '',
	}) {
		this.id = id;
		this.name = name;
		this.address = address;
		// eslint-disable-next-line camelcase
		this.postalCode = postal_code;
		this.city = city;
		this.country = countryDto && new CountryModel(countryDto);
		// eslint-disable-next-line camelcase
		this.fiscalId = fiscal_id;
	}
}

export default BillingInformationModel;
